import isEqual from 'lodash.isequal'
import * as actionTypes from '@store/actions/actionTypes'

const initialState = {
  view: 'loading', // loading, null, selecting, selected, done
  header: false, // When the user has scrolled down, a HUD appears.

  searchBoxText: '',
  suggestions: [],
  subjectProperty: {},
  subjectPropertySearchBoxText: '',

  comps: {
    forSale: [],
    sold: [],
    offMarket: []
  },

  switches: {
    forSaleComps: true,
    soldComps: true,
    avm: true,
    forSaleCompsSqFt: false,
    soldCompsSqFt: false
  },

  avms: []
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.RESTORE_SAVED_CUSTOM_PROP_EVAL:
      return {
        ...state,
        ...action.pe
      }
    case actionTypes.RESET_CUSTOM_PROP_EVAL:
      return {
        ...initialState
        // ...state
        // subjectProperty: state.subjectProperty
      }
    case actionTypes.SET_CUSTOM_PROP_EVAL_VIEW:
      return {
        ...state,
        view: action.view
      }
    case actionTypes.SET_CUSTOM_PROP_EVAL_HEADER:
      return {
        ...state,
        header: action.bool
      }
    case actionTypes.SET_CUSTOM_PROP_EVAL_SEARCHBOX_TEXT:
      return {
        ...state,
        searchBoxText: action.text
      }
    case actionTypes.SET_CUSTOM_PROP_EVAL_SUGGESTIONS:
      return {
        ...state,
        suggestions: action.suggestions
      }
    case actionTypes.SET_CUSTOM_PROP_EVAL_SUBJECT_PROPERTY:
      return {
        ...state,
        subjectProperty: action.property
      }
    case actionTypes.SET_CUSTOM_COMPS:
      return {
        ...state,
        comps: action.comps
      }
    case actionTypes.TOGGLE_CUSTOM_COMP:
      return {
        ...state,
        comps: {
          ...state.comps,
          [action.compType]: state.comps[action.compType].map(t => {
            if (isEqual(t.docId, action.docId)) {
              return { ...t, active: action.active }
            }
            return t
          })
        }
      }
    case actionTypes.TOGGLE_CUSTOM_PROP_EVAL_SWITCH:
      return {
        ...state,
        switches: {
          ...state.switches,
          [action.name]: !state.switches[action.name]
        }
      }
    case actionTypes.SET_CUSTOM_PROP_EVAL_SUBJECT_PROPERTY_SEARCHBOX_TEXT:
      return {
        ...state,
        subjectPropertySearchBoxText: action.text
      }
    case actionTypes.SET_CUSTOM_AVMS:
      return {
        ...state,
        avms: action.avms
      }
    case actionTypes.SET_CUSTOM_PROP_EVAL_SOURCE_ACTIVE:
      return {
        ...state,
        avms: state.avms.map(avm => {
          if (avm.name === action.name) {
            return { ...avm, active: action.active }
          }
          return avm
        })
      }
    default:
      return state
  }
}

export default reducer
